/// <amd-module name="Environments/ProviderCreateDetails/Kubernetes/Telemetry" />
import { IVssTelemetryService } from "VSS/Platform/Telemetry";
import { IVssPageContext } from "VSS/Platform/Context";

export function publishTelemetry(pageContext: IVssPageContext, featureName: string, properties: { [key: string]: string } = {}): void {
    const telemetryService = pageContext.getService<IVssTelemetryService>("IVssTelemetryService");
    telemetryService.publishEvent(Area, featureName, properties);
}

const Area = "Kubernetes_Environment_Resource";

export namespace FeatureNames {
    export const AddK8sRes = "Add_Kubernetes_Resource";
    export const AddK8sResComplete = "Add_Kubernetes_Resource_Complete";
    export const AddK8sResProviderChange = "Add_Kubernetes_Resource_Provider_Change";
    export const AddK8sResFailed = "Add_Kubernetes_Resource_Failed";
    export const AddK8sResProviderType = "Add_Kubernetes_Resource_Provider_Type";
    export const AddK8sResWithExistingSubscription = "Add_Kubernetes_Resource_Existing_Azure_Subscription";

    export const ValidateK8sResComplete = "Validate_Kubernetes_Resource_Complete";
    export const ValidateK8sResFailed = "Validate_Kubernetes_Resource_Failed";

    export const K8sSAClusterFilled = "Kubernetes_Service_Account_Cluster_Filled";
    export const K8sSANamespaceFilled = "Kubernetes_Service_Account_Namespace_Filled";
    export const K8sSASurlFilled = "Kubernetes_Service_Account_ServerUrl_Filled";
    export const K8sSASecretFilled = "Kubernetes_Service_Account_Secret_Filled";

    export const K8sSubClusterFilled = "Kubernetes_Subscription_Cluster_Filled";
    export const K8sSubExistingCluster = "Kubernetes_Subscription_Exisitng_Cluster";
    export const K8sSubNamespaceFilled = "Kubernetes_Subscription_Namespace_Filled";
    export const K8sSubExistingNamespace = "Kubernetes_Subscription_Existing_Namespace";
    export const K8sSubscriptionChanged = "Kubernetes_Subscription_Changed";

    export const EnvironmentCreationWorkFlow = "EnvironmentCreateWorkFlow";
}
